import useAgentRoleContext from 'hooks/useAgentRoleContext';

const EnvironmentBanner = () => {
  const { shouldDisplayWarningBanner } = useAgentRoleContext();

  if (!shouldDisplayWarningBanner) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 w-full z-50">
      <div
        id="uat-banner"
        className="flex items-center justify-between gap-4 shadow-lg px-12 py-2 bg-red-100 border border-red-300 text-red-900">
        <div className="flex items-center gap-4">
          <i className="bi bi-exclamation-triangle-fill text-red-500 text-2xl"></i>

          <div className="text-base md:text-lg font-medium">
            Obecnie pracujesz na środowisku <span className="font-semibold">TESTOWYM</span>.
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnvironmentBanner;
